import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { InternalErrorResponse } from '@/services/transport/types'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiTasksBoardNotFoundError extends TmApiClientError<InternalErrorResponse> {
  public name = 'TmApiTasksBoardNotFoundError'

  protected override code: TmTransportHttpErrorCode = 404

  public shouldBeMonitored(): boolean {
    return false
  }
}
